"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleExport = void 0;
const Shape_1 = require("lincd/lib/shapes/Shape");
const lincd_1 = require("../ontologies/lincd");
const models_1 = require("lincd/lib/models");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const Module_1 = require("./Module");
const URI_1 = require("lincd/lib/utils/URI");
class ModuleExport extends Shape_1.Shape {
    get npmPath() {
        return this.getValue(lincd_1.lincd.npmPath);
    }
    set npmPath(val) {
        this.overwrite(lincd_1.lincd.npmPath, new models_1.Literal(val));
    }
    get module() {
        return this.hasProperty(lincd_1.lincd.module) ? Module_1.Module.getOf(this.getOne(lincd_1.lincd.module)) : null;
    }
    set module(val) {
        this.overwrite(lincd_1.lincd.module, val.namedNode);
    }
    static getModuleExportURI(module, ...names) {
        return (Module_1.Module.getLincdModuleURI(module.packageName, module.version) + '/' + names.map((n) => URI_1.URI.sanitize(n)).join('/'));
    }
}
ModuleExport.targetClass = lincd_1.lincd.ModuleExport;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: lincd_1.lincd.npmPath,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], ModuleExport.prototype, "npmPath", null);
__decorate([
    (0, ShapeDecorators_1.linkedProperty)({
        path: lincd_1.lincd.module,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", Module_1.Module),
    __metadata("design:paramtypes", [Module_1.Module])
], ModuleExport.prototype, "module", null);
exports.ModuleExport = ModuleExport;
//# sourceMappingURL=ModuleExport.js.map